<template>
    <Widget title="Words Data" :area="this.$props.area">
        <template v-if="hasData">
            <NameValue name="Letters" :value="letters"/>
            <NameValue name="Words" :value="words"/>
            <NameValue name="Letters/Comment" :value="letters_comments"/>
            <NameValue name="Words/Comment" :value="words_comments"/>
            <NameValue name="Karma/Letter" :value="karma_letter"/>
            <NameValue name="Karma/Word" :value="karma_word"/>
        </template>
    </Widget>
</template>

<script>
    import Widget from "../Widget";
    import {mapGetters} from "vuex";
    import NameValue from "../NameValue";

    export default {
        components: {NameValue, Widget},
        props: {area: String},
        computed: {
            ...mapGetters(['user', 'comments']),
            comment_count() {
                return this.comments.length;
            },
            hasData() {
                return this.user !== null && this.comment_count > 0
            },
            letters() {
                return this.comments.reduce((a, c) => a + this.purify(c.data.body).replace(/\s+/g, '').length, 0)
            },
            words() {
                return this.comments.reduce((a, c) => a + this.purify(c.data.body).split(' ').length, 0)
            },
            letters_comments() {
                return Math.round((this.letters / this.comment_count) * 10) / 10;
            },
            words_comments() {
                return Math.round((this.words / this.comment_count) * 10) / 10;
            },
            karma_letter() {
                return Math.round((this.user.comment_karma / this.letters) * 10) / 10
            },
            karma_word() {
                return Math.round((this.user.comment_karma / this.words) * 10) / 10
            },
        },
        methods: {
            open() {
            },
            purify(str) {
                return str.replace(/[^\w\s!?]/g, '').replace(/\s+/g, ' ');
            }
        }
    }
</script>

<style scoped>

</style>
